/* eslint-disable max-len */
/* eslint-disable sort-keys */
import { tableCellClasses } from '@mui/material/TableCell'
import { tableRowClasses } from '@mui/material/TableRow'
import { CssVarsThemeOptions } from '@mui/material/styles'

// ----------------------------------------------------------------------

export function table(): CssVarsThemeOptions['components'] {
	return {
		MuiTableContainer: {
			styleOverrides: {
				root: {
					position: 'relative',
				},
			},
		},
		MuiTableRow: {
			styleOverrides: {
				root: ({ theme }) => ({
					[`&.${tableRowClasses.selected}`]: {
						backgroundColor: `rgba(${theme.vars.palette.primary.darkChannel} / 0.04)`,
						'&:hover': {
							backgroundColor: `rgba(${theme.vars.palette.primary.darkChannel} / 0.08)`,
						},
					},
					'&:last-of-type': {
						[`& .${tableCellClasses.root}`]: {
							borderColor: 'transparent',
						},
					},
				}),
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					borderBottomStyle: 'dashed',
				},
				head: ({ theme }) => ({
					fontSize: 14,
					color: theme.vars.palette.text.secondary,
					fontWeight: theme.typography.fontWeightSemiBold,
					backgroundColor: theme.vars.palette.background.default,
				}),
				stickyHeader: ({ theme }) => ({
					backgroundColor: theme.palette.background.paper,
					backgroundImage: `linear-gradient(to bottom, ${theme.vars.palette.background.default} 0%, ${theme.vars.palette.background.default} 100%)`,
				}),
				paddingCheckbox: ({ theme }) => ({
					paddingLeft: theme.spacing(1),
				}),
			},
		},
		MuiTablePagination: {
			styleOverrides: {
				root: {
					width: '100%',
				},
				toolbar: {
					height: 64,
				},
				actions: {
					marginRight: 8,
				},
				select: ({ theme }) => ({
					paddingLeft: 8,
					'&:focus': {
						borderRadius: theme.vars.shape.borderRadius,
					},
				}),
				selectIcon: {
					right: 4,
					width: 16,
					height: 16,
					top: 'calc(50% - 8px)',
				},
			},
		},
	}
}
